import { CREATE_ENTRY_STRATEGY, CREATE_ENTRY_STRATEGY_FAILED, CREATE_ENTRY_STRATEGY_SUCCESSFUL } from './actionTypes';

const initialState = {
  createEntryStrategyError: null,
  messageEntryStrategy: null,
  loadingCreateEntryStrategy: false,
};

const createEntryStrategy = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ENTRY_STRATEGY:
      state = {
        ...state,
        loadingCreateEntryStrategy: true,
        createEntryStrategyError: null,
      };
      break;
    case CREATE_ENTRY_STRATEGY_SUCCESSFUL:
      state = {
        ...state,
        loadingCreateEntryStrategy: false,
        messageEntryStrategy: action.payload,
        createEntryStrategyError: null,
      };
      break;
    case CREATE_ENTRY_STRATEGY_FAILED:
      state = {
        ...state,
        messageEntryStrategy: null,
        loadingCreateEntryStrategy: false,
        createEntryStrategyError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default createEntryStrategy;
